<template>
  <div class="order-list-page">
    <div class="page-header">
      <span class="page-title">居家托养服务记录</span>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">筛选查询</span>
      </div>
      <el-form :inline="true" ref="search" :model="search" class="mt15">
        <el-form-item prop="user_name_or_tel">
          <el-input v-model="search.user_name_or_tel" placeholder="患者姓名/残疾人证件号" clearable></el-input>
        </el-form-item>
        <el-form-item prop="order_no">
          <el-input v-model="search.order_no" placeholder="订单编号" clearable></el-input>
        </el-form-item>
        <el-form-item prop="nurse_name_or_tel">
          <el-input v-model="search.nurse_name_or_tel" placeholder="护工姓名/手机号" clearable></el-input>
        </el-form-item>
        <el-form-item prop="order_status">
          <el-select v-model="search.order_status" placeholder="订单状态" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option v-for="option in OrderStatus" :key="option.val" :label="option.label"
                       :value="option.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="serveTime">
          <el-date-picker
            v-model="search.serveTime"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="服务记录开始时间"
            end-placeholder="服务记录结束时间"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="service_item">
          <el-select v-model="search.service_item" multiple placeholder="服务项" clearable>
            <el-option v-for="option in nurseServices" :key="option.id" :label="option.name"
                       :value="option.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="order">
          <el-radio-group v-model="search.order" @change="searchData">
            <el-radio-button :label="''" :name="''">按时间排序</el-radio-button>
            <el-radio-button :label="'1'" :name="'1'">按患者排序</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetForm('search')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">服务记录列表</span>
        <div class="info-card-extra">
          <span>护理记录总数：{{ total }}</span>
          <el-divider direction="vertical"></el-divider>
          <span>总服务费用：￥{{ service_total }}</span>
        </div>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.6)"
        max-height="600"
        :header-cell-style="{ background: '#fafafa', color: '#303133' }"
        stripe
      >
        <el-table-column prop="order_no" label="订单编号" minWidth="168">
          <template slot-scope="{ row: { id, order_no }}">
            <el-link type="primary" @click="handleDetails(id)" class="op-link">{{ order_no || '—' }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="患者" width="168">
          <template slot-scope="{ row: { user_name, user_tel }}">
            <div class="person-cell">
              <div class="person-name">{{ user_name || '—' }}</div>
              <div class="person-tel">{{ user_tel || '—' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="id_card" label="残疾证号" minWidth="168">
          <template slot-scope="{ row: { id_card }}">
            <span v-if="id_card">{{ id_card }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" minWidth="120" align="center">
          <template slot-scope="{ row: { order_status }}">
            <el-tag size="mini" :type="statusTagType(order_status)" effect="plain">{{ order_status | ordersFilter }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="nurse" label="护工姓名" minWidth="160">
          <template slot-scope="{ row: { nurse_name, nurse_tel }}">
            <div class="person-cell">
              <div class="person-name">{{ nurse_name || '—' }}</div>
              <div class="person-tel">{{ nurse_tel || '—' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="地址" width="240">
          <template slot-scope="{ row: { hospital_name, address, bed_no }}">
            <div class="address-cell">
              <span v-if="hospital_name">{{ hospital_name }}</span>
              <span v-if="address">/ {{ address }}</span>
              <span v-if="bed_no">/ {{ bed_no }}</span>
              <span v-if="!hospital_name && !address && !bed_no" class="empty-text">—</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column minWidth="200" label="护理记录时间">
          <template slot-scope="{ row: { dis_start_at, dis_end_at }}">
            <div v-if="dis_start_at" class="time-cell">
              <div class="time-line">
                <i class="el-icon-time"></i>
                <span>{{ (dis_start_at * 1000) | formatDate('yyyy-MM-dd HH:mm') }}</span>
              </div>
              <div class="time-line time-end">
                <i class="el-icon-finished"></i>
                <span>{{ (dis_end_at * 1000) | formatDate('yyyy-MM-dd HH:mm') }}</span>
              </div>
            </div>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="record_name" label="服务项目" minWidth="240" class-name="service-item-col">
          <template slot-scope="{ row }">
            <div v-if="row.services && row.services.length" class="service-list">
              <div v-for="(s, i) in row.services" :key="i" class="service-line">{{ s.name }} ￥{{ s.price }}</div>
            </div>
            <div v-else-if="row.record_name" class="service-list">
              <div v-for="(name, i) in String(row.record_name).split(/[,，、]/).filter(Boolean)" :key="i" class="service-line">{{ name.trim() }}</div>
            </div>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="本次服务费" minWidth="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.record_price">￥{{ scope.row.record_price }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          :current-page="page_number"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { fetchFosterRecordList } from '@/api'
import { OrderStatus } from '@/enum/orders'
import { filterEnum } from '@/utils/filter'
import { OrderAllStatus } from '../../enum/orders'
import { formatDate } from 'element-ui/lib/utils/date-util'
import { delOrderById, fetchNurseServices } from '../../api'
import { isAdmin } from '../../utils/util'
import { confirmDeleteOrder } from '@/utils/confirm-delete'

export default {
  name: 'OrdersFoster',
  data() {
    return {
      OrderStatus,
      is_finance: 1,
      is_hospital: 1,
      isAddNurse: false,
      nurseServices: [],
      fileList: [],
      search: {
        serveTime: [],
        service_item: [],
        order: '',
        user_name_or_tel: '',
        nurse_name_or_tel: '',
        order_status: ''
      },
      tableLoading: false,
      page_size: 10,
      page_number: 1,
      total: 0,
      service_total: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      tableData: []
    }
  },
  filters: {
    formatDate,
    ordersFilter(val) {
      return filterEnum(val, OrderAllStatus).label || '-'
    },
    nurseNameTel(val) {
      const { nurse_name, nurse_tel } = val
      let str = ''

      if (nurse_name && nurse_name !== '') {
        str += nurse_name
      } else {
        str += '-'
      }
      if (nurse_tel && nurse_tel !== '') {
        str += '/'
        str += nurse_tel
      } else {
        str += '/'
        str += '-'
      }
      return str
    }
  },
  computed: {
    isAdmin() {
      return isAdmin()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    formatDate,
    statusTagType(status) {
      const map = { 1: 'warning', 10: 'info', 20: 'info', 30: 'primary', 60: 'success', 50: 'danger', 41: 'danger', 40: 'warning', 2: 'info' }
      return map[status] || 'info'
    },
    init() {
      // order_status 0 超级管理员 1无权限 2有权限 默认1无权限
      const is_finance = sessionStorage.getItem('is_finance')
      const is_hospital = sessionStorage.getItem('is_hospital')
      this.is_finance = is_finance
      this.is_hospital = is_hospital
      this.fetchNurseServices()
      this.getList()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.page_number = 1
      this.getList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.page_size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_number = val
      this.getList()
    },
    searchData() {
      this.page_number = 1
      this.getList()
    },
    fetchNurseServices() {
      fetchNurseServices()
        .then(res => {
          if (res.status) {
            this.nurseServices = res.data
          } else {
            this.nurseServices = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    toYmd(v) {
      if (v == null || v === '') return ''
      if (typeof v === 'string') {
        const m = v.trim().match(/^(\d{4}-\d{2}-\d{2})/)
        if (m) return m[1]
      }
      const n = Number(v)
      const d = Number.isFinite(n) && n > 1e9
        ? new Date(n < 1e12 ? n * 1000 : n)
        : (v instanceof Date ? v : new Date(v))
      if (isNaN(d.getTime())) return ''
      const y = d.getFullYear()
      const m = d.getMonth() + 1
      const day = d.getDate()
      return `${y}-${m < 10 ? '0' : ''}${m}-${day < 10 ? '0' : ''}${day}`
    },
    getList() {
      this.tableLoading = true
      try {
        const {
          page_size, page_number, search
        } = this
        const { serveTime, service_item, ...searchInfo } = search
        const params = {
          service_item: service_item.join(','),
          page_size: page_size,
          page_number: page_number,
          ...searchInfo
        }
        if (serveTime && serveTime.length === 2 && serveTime[0] && serveTime[1]) {
          const startDay = this.toYmd(serveTime[0])
          const endDay = this.toYmd(serveTime[1])
          params.dis_start_at = startDay ? `${startDay} 00:00:00` : ''
          params.dis_end_at = endDay ? `${endDay} 23:59:59` : ''
        }
        fetchFosterRecordList(params)
          .then(res => {
            if (res.status) {
              this.tableData = (res.data && res.data.list) || []
              this.total = (res.data && res.data.total) || 0
              this.service_total = (res.data && res.data.service_total) || 0
            } else {
              this.tableData = []
            }
          })
          .catch(() => {
            this.tableData = []
          })
          .finally(() => {
            this.tableLoading = false
          })
      } catch (e) {
        this.tableData = []
        this.tableLoading = false
      }
    },
    handleDetails(_RowId) {
      this.$router.push({
        path: '/order-details',
        query: {
          id: _RowId,
          type: 'orders_foster_records'
        }
      })
    },

    handleDelete(order_id, orderNo) {
      confirmDeleteOrder(this, `确定删除订单${orderNo}吗?`)
        .then(() => {
          delOrderById({
            order_id
          }).then(res => {
            if (res.status) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-list-page {
  padding: 16px 20px 30px;
}
.page-header {
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.mt20 { margin-top: 20px; }
.mt15 { margin-top: 15px; }
.info-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.info-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #f2f6fc;
}
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  position: relative;
  padding-left: 10px;
}
.info-card-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: #26a4b2;
  border-radius: 2px;
}
.info-card-extra {
  color: #26a4b2;
  font-weight: 600;
  font-size: 13px;
}
.person-cell { line-height: 1.6; }
.person-name { color: #303133; font-weight: 500; }
.person-tel { color: #909399; font-size: 13px; }
.address-cell { color: #606266; line-height: 1.6; }
.time-cell { line-height: 1.6; }
.time-line { display: flex; align-items: center; color: #303133; font-size: 13px; }
.time-line i { color: #26a4b2; margin-right: 6px; font-size: 14px; }
.time-end { color: #909399; }
.time-end i { color: #67c23a; }
.service-list { width: 100%; }
.service-line {
  display: block;
  width: 100%;
  margin-bottom: 4px;
  padding: 2px 8px;
  background: rgba(38, 164, 178, 0.08);
  border-left: 3px solid #26a4b2;
  border-radius: 2px;
  color: #303133;
  font-size: 12px;
  line-height: 1.5;
  word-break: break-all;
  white-space: normal;
}
.service-line:last-child { margin-bottom: 0; }
::v-deep .service-item-col .cell { overflow: visible !important; white-space: normal !important; line-height: 1.6; }
.empty-text { color: #c0c4cc; }
.op-link { margin-right: 12px; }
.block {
  text-align: center;
  margin-top: 20px;
}
</style>
